import { Identifiable, Resource, WeeklyCalendar } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function editResourceWeeklyCalendar(httpClient: HttpClient) {
  return (
    resource: Identifiable<Resource>,
    calendar: Identifiable<WeeklyCalendar>,
    nextCalendar: WeeklyCalendar,
  ) =>
    httpClient.sendHttpRequest<void>({
      endpoint: `/weeklyCalendars/${calendar.uuid}`,
      method: HttpMethods.PATCH,
      data: Object.entries(nextCalendar).reduce(
        (cal, [key, value]) => ({ ...cal, [`${key}Hours`]: value.capacity }),
        {},
      ),
    });
}

export { editResourceWeeklyCalendar };
